import { render } from "./ApplicantSection.vue?vue&type=template&id=49797db2"
import script from "./ApplicantSection.vue?vue&type=script&lang=js"
export * from "./ApplicantSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__